<template lang="html">

<div class="pe_completedmodal_container">
    <div class="pe_completedmodal_close-button"><span @click="$emit('CloseCompletedModal')">X</span></div>
    <div class="pe_completedmodal_main-content">
      <div class="pe_completedmodal_row" v-if="compID == 0">
        <div class="pe_completedmodal_row pe_logo"><Logo /></div>
      
        <div class="pe_completedmodal_row pe_mt_2"><h1>Congratulations!</h1></div>
        <div class="pe_completedmodal_row pe_mt_1"><span v-if="game.completed"><b>Total time:</b> {{ myTotalTime(totalTime,hintsUsed) }}</span></div>
        <div class="pe_completedmodal_row pe_cm_sub" v-if="hintsUsed > 0">Solve time: {{ secondsToHms(Math.floor(totalTime/1000)) }}</div>
        <div class="pe_completedmodal_row pe_cm_sub" v-if="hintsUsed > 0">{{ displayForHints() }}</div>
          
        <div class="pe_completedmodal_row pe_mt_1"><span v-if="game.completed"><b>Your best time:</b> {{ myBestTime(game.puzzleBestTime, totalTime, hintsUsed) }}</span></div>



        <div class="pe_completedmodal_row pe_mt_1">
              <div class="pe_completemodal_white" v-if="showRank">
                  <div>Current rank: <strong v-if="rank && total">{{ rank }} of {{ total }}</strong> <Spinner type="circle" v-else /></div>
                  <div>
                    Best time: {{ secondsToHms(bestPuzzleTime) }}
                  </div>
                  <!--<div>Rank (all players): </div>
                  <div>
                    <strong v-if="rank && total">{{ rankAll }} of {{ totalAll }}</strong> 
                    <Spinner type="circle" v-else />
                  </div>-->
                </div>
          </div>

          <div :class="['pe_completedmodal_row pe_mb_1', compButtonsSpacerClass]">
          <router-link 
                  to="/"
                  :class="['pe_completedmodal_btn', gameClasses]"
                > 
                  Main Menu
                </router-link>
          </div>


        <div class="pe_completedmodal_row pe_mb_1">
              <router-link 
                  to="/archive"
                  :class="['pe_completedmodal_btn', gameClasses]"
                  v-if="compID == 0"
                >
                  Play Previous Puzzles
              </router-link></div>

      </div>
    
    <div class="pe_completedmodal_row pe_mt_1" v-if="compID > 0">
        <CompetitionForm></CompetitionForm>
    </div>
      <!-- <div class="pe_completedmodal_row pe_mt_2">
        <hr style="width:500px;">
      </div> -->
        

          <div class="pe_completedmodal_row pe_mt_1 pe_mb_1">
              <span class="pe_close_btn" @click="$emit('CloseCompletedModal')">CLOSE</span>
          </div>
</div>
  </div>

  
  </template>
  
  <script lang="js">
  
  import { mapState, mapGetters, mapActions } from 'vuex'

  import Logo from '@puzzleapps/shared/src/components/ui/logos/Heart'
  import Stopwatch from '@puzzleapps/shared/src/components/ui/StopWatch'
  import Trophy from '@puzzleapps/shared/src/components/ui/icons/Trophy'
  import Spinner from '@puzzleapps/shared/src/components/ui/Spinner'
  import CompetitionForm from '@puzzleapps/shared/src/components/ui/CompetitionForm'
  
  import api from '@puzzleapps/shared/src/utils/api'
  
    export default  {
      name: 'difficulty-select',
      props: ['date', 'closeBtn'], // date, format YYYY-MM-DD
      
      components: {
        Stopwatch,
        Trophy,
        Spinner,
        Logo,
        CompetitionForm,
      },
  
      data() {
        return {
          rank: null,
          rankAll: null,
          total: null,
          totalAll: null,
          showRank: false,
          manuallyClosedModal : false,
          bestPuzzleTime: null,
          bestClientPuzzleTime: null,
          hideCompModal: false,
        }
      },
  
      mounted() {
        if (this.game.playId && this.gameMode === 'challenge' && this.game.hintsUsed < 1) {
          api.rank(this.game.playId)
          .then(rank => {
            if (rank.noRank) {
              this.showRank = false
            }
            else {
              /*this.showRank = true
              this.rank = rank.rank
              this.rankAll = rank.rankAll
              this.total = rank.total
              this.totalAll = rank.totalAll
              this.bestPuzzleTime = rank.bestPuzzleAllTime
              this.bestClientPuzzleTime = rank.bestPuzzleClientTime*/
            }
          })
        }
        else
        {
          this.manuallyClosedModal = false
        }
      },
  
      methods: {
        ...mapActions({
          resetPuzzle: 'game/resetPuzzle',
        }), 
        
        onManuallyClosedModal()
        {
          this.manuallyClosedModal = true
        },

        displayForHints(){
            let start = this.gameType == "crossword" ? "Letter hints:" : "Hints used:"
            let hintString = this.hintsUsed
            let timeString = "(+" + this.hintPenaltyTime(this.hintsUsed) + ")"
            return start + " " + hintString + " " + timeString
        },
        hintPenaltyTime(hints)
        {
            let penaltyMultiplier = 10

            if(this.gameType === 'sudoku')
                penaltyMultiplier = 15

            //if(this.gameType === 'wordsearch')
                //penaltyMultiplier = 1 //instead of using a multiplier for wordsearch I just add it to the hints counter at the time the hint is used. 15 for a word and 5 for a letter. I probably should use that for all puzzles if there is time

            return this.secondsToHms(Math.floor(hints * penaltyMultiplier))
        },
  
        secondsToHms(seconds) {
          const hours = Math.floor(seconds / 3600);
          const minutes = Math.floor((seconds % 3600) / 60);
          const secondsRemainder = seconds % 60;
          const hoursString = hours.toString().padStart(2, '0');
          const minutesString = minutes.toString().padStart(2, '0');
          const secondsString = secondsRemainder.toString().padStart(2, '0');
  
          if(hours > 0)
            return `${hoursString}:${minutesString}:${secondsString}`;
          else
            return `${minutesString}:${secondsString}`;
  
        },
  
        myTotalTime(tTime, hintCount){
            let penaltyMultiplier = 10000

            if(this.gameType === 'sudoku')
                penaltyMultiplier = 15000

            //if(this.gameType === 'wordsearch')
                //penaltyMultiplier = 1

            let totalTime = tTime + (penaltyMultiplier * hintCount)

            return this.secondsToHms(Math.floor(totalTime/1000))
            
        },
        myBestTime(bTime, tTime, hintCount)
        {
            let penaltyMultiplier = 10000

            if(this.gameType === 'sudoku')
                penaltyMultiplier = 15000

          let penaltyTime = tTime + (penaltyMultiplier * hintCount)
         
          if(bTime > 0)
          {
            if(penaltyTime < bTime)
            {
              return this.secondsToHms(Math.floor(penaltyTime/1000))
            }
            else
            {
              return this.secondsToHms(Math.floor(bTime/1000))
            }
          }
          else
          {
            return this.secondsToHms(Math.floor(penaltyTime/1000))
          }
            
        }
  
  
      },
  
      computed: {
        ...mapState({
          game: state => state.game,
          gameMode: state => state.userSettings.gameMode,
          allowHints: state => state.userSettings.allowHints,
          triviaData: state => state.grid.triviaData,
          completed: state => state.game.completed,
          bestTime: state => state.game.puzzleBestTime,
          totalTime: state => state.game.totalTime,
          hintsUsed: state => state.game.hintsUsed,
          gameType: state => state.game.type,
          compID: state => state.game.competitionID,
        }),

        gameClasses() {  
        let classes = {
          [this.gameType] : true,

        }
        return classes
        },

        compButtonsSpacerClass(){
          let classes = {
            ['pe_mt_2'] : this.compID > 0 ? true : false, // bigger spacing if it is the competition display
            ['pe_mt_1'] : this.compID == 0 ? true : false,
          }
          return classes
        },
  
        ...mapGetters({
          formattedTotalTime: 'game/formattedTotalTime',
          adjustedTotalTime: 'game/formattedAdjustedTime'
        }),
  
      }
    }
  
  </script>
  
  <style scoped lang="scss">
  @import '@puzzleapps/shared/src/style/completedModal2';
  </style>